import React, { useEffect, useRef, useState } from "react";
import {
  //Layout,
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  //PageHeader,
  Radio,
  Row,
  Select,
  Upload,
  notification,
  Space,
  Table,
  Popconfirm,
  Tag,
  Alert,
  Spin,
  Checkbox
} from "antd";
import {
  UploadOutlined,
  FileExcelOutlined,
  SaveOutlined,
  SearchOutlined,
  ReloadOutlined,
  CloseCircleTwoTone,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { ExcelRenderer } from "react-excel-renderer";
import ReactExport from "react-export-excel";

//api
import storesApi from "constants/api/stores";
import brandApi from "constants/api/apiBrand";

import util from "helpers/util";
import itemTakeApi from "constants/api/itemTake";

//const { TabPane } = Tabs;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function CreateTake() {
  const [btnSubmitLoading, setBtnSubmitLoading] = useState(false);
  const [btnSubmitDisabled, setBtnSubmitDisabled] = useState(false);
  const [dataSetStores, setDataSetStores] = useState([]);
  const [isLoadingTab1, setIsLoadingTabCreateTake] = useState(false);
  const [isLoadingTbStore, setIsLoadingTbStore] = useState(false);

  
  const [uploadStore, setUploadStore] = useState(false);
  //item
  const [rowsItem, setRowsItem] = useState([]);

  //store
  const [selectedRowKeysStore, setSelectedRowKeysStore] = useState([]);
  const [rowsStore, setRowsStore] = useState([]);

  const [tbItemSearchText, setTbItemSearchText] = useState("");
  const [tbItemSearchedColumn, setTbItemSearchedColumn] = useState("");
  const tbItemSearchInput = useRef(null);

  const [tbStoreSearchText, setTbStoreSearchText] = useState("");
  const [tbStoreSearchedColumn, setTbStoreSearchedColumn] = useState("");
  const tbStoreSearchInput = useRef(null);

  //brands
  const [brands, setBrands] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);

  const [todayDate, setTodayDate] = useState("");

  const handleDeleteStore = (key) => {
    const rows = rowsStore;
    setRowsStore(rows.filter((item) => item.key !== key));
    setSelectedRowKeysStore(selectedRowKeysStore.filter((item) => item !== key));
  };

  const toggleSelectAll = () => {
    setSelectedRowKeysStore((keys) =>
      keys.length === rowsStore.length ? [] : rowsStore.map((r) => r.key)
    );
  };

  const headerCheckbox = (
    // Disable Check / Uncheck All feature
    // <Checkbox
    //   checked={selectedRowKeysStore.length}
    //   indeterminate={
    //     selectedRowKeysStore.length > 0 && selectedRowKeysStore.length < rowsStore.length
    //   }
    //   onChange={toggleSelectAll}
    // />
    <></>
  );

  const handleSelect = (record, selected) => {
    if (selected) {
      setSelectedRowKeysStore((keys) => [...keys, record.key]);
    } else {
      setSelectedRowKeysStore((keys) => {
        const index = keys.indexOf(record.key);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });
    }
  };

  useEffect(() => {
    //page load
    storesApi
      .activeStores()
      .then((res) => {
        if (res) {
          setDataSetStores(res);
        }
      })
      .catch((err) => {
        util.displayApiError(err);
      });
  },[]);

  useEffect(() => {
    itemTakeApi.getDateTimeNow()
    .then((res) => {
      setTodayDate(res.result);
    })
  }, [])

  const disabledDate = (current) => {
    let result = new Date(todayDate);
    //result.setDate(result.getDate() + addDate);
    result.setDate(result.getDate());

    return current < result;
  };
  
  //Item
  const tbItemGetColumnSearchProps = (dataIndex) => ({
    // eslint-disable-next-line react/display-name
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={tbItemSearchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            tbItemHandleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => tbItemHandleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => tbItemHandleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setTbItemSearchText(selectedKeys[0]);
              setTbItemSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    // eslint-disable-next-line react/display-name
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        // setTimeout(() => searchInput.select(), 100);
      }
    },
    // eslint-disable-next-line react/display-name
    render: (text) =>
      tbItemSearchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[tbItemSearchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  useEffect(() => {
    //setIsLoadingTbOL(true);
    brandApi
      .getBrandsByUser()
      .then((res) => {
        setBrands(res);
      })
      .catch((err) => {
        util.displayApiError(err);
      })
      //.finally(() => setIsLoadingTbOL(false));
  }, []);

  const tbItemHandleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setTbItemSearchText(selectedKeys[0]);
    setTbItemSearchedColumn(dataIndex);
  };

  const tbItemHandleReset = (clearFilters) => {
    clearFilters();
    setTbItemSearchText("");
  };

  //Store
  const tbStoreGetColumnSearchProps = (dataIndex) => ({
    // eslint-disable-next-line react/display-name
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={tbStoreSearchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            tbStoreHandleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              tbStoreHandleSearch(selectedKeys, confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => tbStoreHandleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setTbStoreSearchText(selectedKeys[0]);
              setTbStoreSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    // eslint-disable-next-line react/display-name
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        // setTimeout(() => tbStoreSearchInput.select(), 100);
      }
    },
    // eslint-disable-next-line react/display-name
    render: (text) =>
      tbStoreSearchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[tbStoreSearchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const tbStoreHandleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setTbStoreSearchText(selectedKeys[0]);
    setTbStoreSearchedColumn(dataIndex);
  };

  const tbStoreHandleReset = (clearFilters) => {
    clearFilters();
    setTbStoreSearchText("");
  };

  const columnsStore = [
    {
      title: "Store ID",
      dataIndex: "storeId",
      ...tbStoreGetColumnSearchProps("storeId"),
    },
    {
      title: "Store Name",
      //width:300,
      dataIndex: "storeName",
      ...tbStoreGetColumnSearchProps("storeName"),
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
      ...tbItemGetColumnSearchProps("status"),
      render: (text, record) =>
        text === "Open" ? (
          <Tag color="success">Open</Tag>
        ) : text === "Invalid store id" ? (
          <Tag color="error">Invalid <br />
          store ID</Tag>
        ) : (
          <Tag color="error">Close</Tag>
        ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) =>
        rowsStore.length >= 1 ? (
          <Popconfirm
            title="Sure to remove?"
            onConfirm={() => handleDeleteStore(record.key)}
          >
            <CloseCircleTwoTone twoToneColor="#f50" />
            &nbsp;Remove
          </Popconfirm>
        ) : null,
    }
  ];

  const fileHandlerStore = (fileList) => {
    setIsLoadingTbStore(true);
    let fileObj = fileList;
    if (!fileObj) {
      notification.error({
        message: "No file uploaded",
        duration: 0,
      });

      //setErrorMessageStore("No file uploaded!");
      setIsLoadingTbStore(false);
      return false;
    }
    if (
      !(
        fileObj.type === "application/vnd.ms-excel" ||
        fileObj.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      )
    ) {
      notification.error({
        message: "Error",
        description: "Unknown file format. Only Excel files are uploaded",
        duration: 0,
      });
      
      setRowsStore([]);
      setIsLoadingTbStore(false);
      return false;
    }
    //just pass the fileObj as parameter
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        util.displayApiError(err);
      } else {
        let param = [];
        let newRows = [];
        let originalStoreExcel = [];
        resp.rows.slice(1).map((row, index) => {
          if (row && row !== "undefined") {
            if (row[0]) {
              param.push(row[0]);
              originalStoreExcel.push({
                storeId: row[0],
                storeName: row[1]
              });
            } 
          }
        });
        if (param.length === 0) {
          notification.error({
            message: "Error",
            description: "No valid data found in file!",
            duration: 0,
          });

          setRowsStore([]);
          setIsLoadingTbStore(false);
          return false;
        } else {
          storesApi
            .load(param)
            .then((res) => {
              res.map((row) => {
                newRows.push({
                  key: row.storeId,
                  storeId: row.storeId,
                  storeName: row.storeName,
                  status: row.status
                });
              });

              const storesId = res.map(data => data.storeId)
              const invalidStore = originalStoreExcel.filter((storeExcel) => !storesId.includes(storeExcel.storeId))
              invalidStore.map((row) => {
                newRows.push({
                  //bandingkan dengan data yang didapat dari excel untuk dapat store name nya
                  key: row.storeId,
                  storeId: row.storeId,
                  storeName: row.storeName,
                  status: "Invalid store id"
                });
              });

              setRowsStore(newRows);
              setSelectedRowKeysStore(newRows.map((item) => item.key));
              setIsLoadingTbStore(false);
            })
            .catch((err) => {
              util.displayApiError(err);
              setIsLoadingTbStore(false);
            });
        }
      }
    });
    return false;
  };

  const [form] = Form.useForm();
  const dateFormat = "YYYY-MM-DD";

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.filelist;
  };

  // const onSelectChange = (selectedRowKeys) => {
  //   setSelectedRowKeysStore(selectedRowKeys);
  // };

  const onApplyToStoreChange = (e) => {
    var val = e.target.value;
    const uploadStoreTemp = val == "2" ? true : false;
    let newRows = [];
    if (!uploadStoreTemp) {
      //get all active store
      setIsLoadingTbStore(true);
      dataSetStores.map((row, index) => {
        newRows.push({
          key: row.storeId,
          storeId: row.storeId,
          storeName: row.storeName,
          status: row.status
        });
      });
      setRowsStore(newRows);
      setSelectedRowKeysStore([]);
      setIsLoadingTbStore(false);
    } else {
      setRowsStore([]);
      setSelectedRowKeysStore([]);
      setIsLoadingTbStore(false);
    }
    setUploadStore(uploadStoreTemp);
  };

  //FINISH
  const onFinish = (values) => {
    setBtnSubmitLoading(true);
    setIsLoadingTabCreateTake(true);

    const storeIds = rowsStore
      .filter(({ key }) => selectedRowKeysStore.includes(key))
      .map((row) => {
        return { storeId: row.key };
    });

    const statusStore = rowsStore.filter(({ storeId, status }) => 
      status != 'Open' &&
      selectedRowKeysStore.includes(storeId)
    );
    if (statusStore.length > 0) {
      notification.error({
        message: "Error",
        description: "Please uncheck store with invalid status",
      });
      setBtnSubmitLoading(false);
      setIsLoadingTabCreateTake(false);
      return;
    }

    if (storeIds.length === 0) {
      notification.error({
        message: "Error",
        description: "No store data",
      });
      
      setBtnSubmitLoading(false);
      setIsLoadingTabCreateTake(false);
      return;
    }

    var dataForSubmit = {
      stores: selectedRowKeysStore,
      brands: selectedBrands,
      actionDate: values.actionDate.format(dateFormat)
    };

    itemTakeApi
      .uploadItemTake(dataForSubmit)
      .then((res) => {
        if (res.success) {
          setBtnSubmitLoading(false);
          setIsLoadingTabCreateTake(false);
          resetForm();
          
          notification.success({
            message: "Success",
            description: res.message,
            duration: 0,
          });

          setBtnSubmitDisabled(false);
        } else {
          notification.error({
            message: "Failed",
            description: res.message,
            duration: 0,
          });
          
          setBtnSubmitLoading(false);
          setIsLoadingTabCreateTake(false);
        }
      })
      .catch((err) => {
          notification.error({
          message: "Internal server error. please contact administrator",
          duration: 0,
        });
        setBtnSubmitLoading(false);
        setIsLoadingTabCreateTake(false);
      });
  };

  const resetForm = () => {
    form.resetFields();
    setRowsItem([]);
    setRowsStore([]);
    setSelectedBrands([]);
    setUploadStore(false);
    setBtnSubmitDisabled(false);
  };

  return (
    <>
      <Spin tip="Submitting..." size="large" spinning={isLoadingTab1}>
        <Form
          layout="vertical"
          form={form}
          size="middle"
          style={{ paddingLeft: 16, paddingRight: 16 }}
          onFinish={onFinish}
        >
          <Row gutter={16}>
            <Col
              span={12}
              style={{
                backgroundColor: "#DDF7F9",
                padding: 4,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Space direction="vertical" size="middle">
                <Form.Item
                  name="brand"
                  label="Brand:"
                >
                  <Select
                    key="brandsDropdown"
                    mode="multiple"
                    size="middle"
                    placeholder="All brands selected"
                    maxTagCount="responsive"
                    allowClear
                    filterOption={(input, option) =>
                      option.key.toLowerCase().includes(input.toLowerCase()) ||
                      String(option.value)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    onSelect={(value) => {
                      setSelectedBrands([...selectedBrands, value]);
                    }}
                    onDeselect={(value) => {
                      setSelectedBrands(
                        selectedBrands.filter(
                          (oldValues) => oldValues !== value
                        )
                      );
                    }}
                    onClear={() => setSelectedBrands([])}
                    style={{ width: 400, fontSize: 12, textAlign: "start" }}
                  >
                    {brands.map((brand) => {
                      return (
                        <Select.Option
                          key={brand.brandName}
                          title={`Brand ID: ${brand.brandId}`}
                          value={brand.brandId}
                          style={{ fontSize: 12 }}
                        >
                          {brand.brandName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Space>
            </Col>

            <Col 
              span={12} 
              style={{
                backgroundColor: "#DDF7F9",
                padding: 4,
                display: "flex",
              }}
            >
              <Form.Item 
                name="actionDate"
                label="Action Date:"
                rules={[
                  {
                    required: true,
                    message: "Action date is required",
                  },
                ]}
                red
              >
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>
          </Row>
          
          <br />

          <Row gutter={16}>
            <Col
              span={12}
              style={{
                backgroundColor: "#DDF7F9",
                padding: 4,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Space direction="vertical" size={0}>
                <Form.Item
                  name="radio-group"
                  label="APPLY TO STORE:"
                  rules={[
                    {
                      required: true,
                      message: "Store is required",
                    },
                  ]}
                  red
                >
                  <Radio.Group onChange={onApplyToStoreChange}>
                    <Radio value="1">All Stores</Radio>
                    <Radio value="2">Apply to selected store(s)</Radio>
                  </Radio.Group>
                </Form.Item>
                {uploadStore ? (
                  <Space align="start">
                    <ExcelFile
                      element={
                        <Button icon={<FileExcelOutlined />}>
                          Sample File
                        </Button>
                      }
                      filename="Sample Store"
                    >
                      <ExcelSheet data={dataSetStores} name="Sheet1">
                        <ExcelColumn label="STORE" value="storeId" />
                        <ExcelColumn label="STORE NAME" value="storeName" />
                      </ExcelSheet>
                    </ExcelFile>
                    <Form.Item
                      name="uploadItem"
                      valuePropName="filelist"
                      getValueFromEvent={normFile}
                      extra=""
                    >
                      <Upload
                        name="file"
                        beforeUpload={fileHandlerStore}
                        onRemove={() => setRowsStore([])}
                        multiple={false}
                        maxCount={1}
                      >
                        <Button type="primary" icon={<UploadOutlined />}>
                          Upload XLSX
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Space>
                ) : null}
              </Space>
            </Col>
            <Col
              span={12}
              style={{ backgroundColor: "#DDF7F9", padding: 4 }}
            >
              <Table
                loading={isLoadingTbStore}
                size="small"
                columns={columnsStore}
                rowSelection={{
                  selectedRowKeys: selectedRowKeysStore,
                  type: "checkbox",
                  fixed: true,
                  onSelect: handleSelect,
                  columnTitle: headerCheckbox
                }}
                dataSource={rowsStore}
                // pagination={{ pageSize: 5 }}
                pagination={false}
                scroll={{ y: 200 }}
                bordered
              />
              <Alert
                message={`Total data selected: ${selectedRowKeysStore.length} row(s)`}
                type="info"
                showIcon
              />
            </Col>
          </Row>
          
          <br />
          
          <Form.Item>
            <Space>
              <Button
                icon={<SaveOutlined />}
                size="large"
                type="primary"
                htmlType="submit"
                loading={btnSubmitLoading}
                disabled={btnSubmitDisabled}
              >
                Submit
              </Button>
              <Button
                icon={<ReloadOutlined />}
                size="large"
                onClick={resetForm}
              >
                Reset Form
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Spin>
    </>
  );
}
